import { Card, CardContent, Stack, Typography } from '@mui/material';
import { format, parseISO } from 'date-fns';
import { LabelValueRow } from '../LabelValueRow';
import type { PotApprovals } from '../../types/potDetails.types';

interface PotTimelineCardProps {
  approvals: PotApprovals;
}

export function PotTimelineCard({ approvals }: PotTimelineCardProps) {
  const formatDateTime = (dateString: string) =>
    format(parseISO(dateString), 'dd MMM yyyy, HH:mm');

  const hasTimeline =
    approvals.submittedAt || approvals.approvedAt || approvals.rejectedAt;

  if (!hasTimeline) return null;

  return (
    <Card variant="outlined" data-testid="pot-timeline-card">
      <CardContent
        sx={{
          p: { xs: 2, sm: 3 },
          '&:last-child': { pb: { xs: 2, sm: 3 } },
        }}
      >
        <Typography variant="h6" sx={{ mb: 2 }}>
          Activity
        </Typography>
        <Stack spacing={0.5}>
          {approvals.submittedAt && approvals.submittedByName && (
            <LabelValueRow
              label="Submitted"
              value={
                <Typography variant="body2" color="text.secondary">
                  {formatDateTime(approvals.submittedAt)} by{' '}
                  {approvals.submittedByName}
                </Typography>
              }
            />
          )}
          {approvals.approvedAt && approvals.approvedByName && (
            <LabelValueRow
              label="Approved"
              value={
                <Typography variant="body2" color="success.main">
                  {formatDateTime(approvals.approvedAt)} by{' '}
                  {approvals.approvedByName}
                </Typography>
              }
            />
          )}
          {approvals.rejectedAt && approvals.rejectedByName && (
            <LabelValueRow
              label="Rejected"
              value={
                <Typography variant="body2" color="error.main">
                  {formatDateTime(approvals.rejectedAt)} by{' '}
                  {approvals.rejectedByName}
                </Typography>
              }
            />
          )}
        </Stack>
      </CardContent>
    </Card>
  );
}
